import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * The supervision area's front door, which is the queue board.
 *
 * A redirect rather than a screen of its own: the area has two boards and one of them is where a
 * supervisor starts a shift — what is waiting, and whether anybody is answering it. A landing page
 * with two links would be one more click between a supervisor and the queue that is filling up.
 */
export const Route = createFileRoute('/supervise/')({
  beforeLoad() {
    throw redirect({ to: '/supervise/queues', search: { queueIds: [], period: 'today' } });
  },
});
